import Braintree from 'braintree-web/client';
import HostedFields from 'braintree-web/hosted-fields';
import DataCollector from 'braintree-web/data-collector'
import { hostedFieldsOption, hostedFieldsOptionAble,
    hostedFieldsClassStruture, hostedFieldsRequiredAndInvalid } from './card-option-config';
import { validateHostedFields, validateHostedFieldsAble } from './validate-hosted-fields';

export default class BraintreeClientApi {
    private hostedFields;
    private authorization;
    private deviceData;
    public constructor({ authorization}) {
        this.authorization = authorization;
    }

    public setAuthorization = (onClientInstanceCallback) => {
        Braintree.create({ authorization: this.authorization }, (err, clientInstance) => {
            if (err) {
                this.onError(err)
            } else {
                onClientInstanceCallback(clientInstance);
            }
        });
    }

    public getDatCollectorInstance = (client) => {
        DataCollector.create({
            client,
            kount: true
        }, (err, dataCollectorInstance) => {
            if (err) {
                return;
            } else {
                this.deviceData = dataCollectorInstance.deviceData;
            }
        });
    }

    public getHostedFieldsInstance = (client, onHostedFieldInstanceCallback) => {
        HostedFields.create({
            client,
            fields: hostedFieldsOption.fields,
            styles: hostedFieldsOption.styles
        }, (err, hostedFieldsInstance) => {
            if (err) {
                return;
            } else {
                this.hostedFields = hostedFieldsInstance.focus('number');
                this.hostedFields = hostedFieldsInstance;

                onHostedFieldInstanceCallback(hostedFieldsInstance);
            }
        });
    }

    public getHostedFieldsInstanceAble = (client, onHostedFieldInstanceCallback) => {
        HostedFields.create({
            client,
            fields: hostedFieldsOptionAble.fields,
            styles: hostedFieldsOptionAble.styles
        }, (err, hostedFieldsInstance) => {
            if (err) {
                return;
            } else {
                this.hostedFields = hostedFieldsInstance.focus('number');
                hostedFieldsInstance.on('focus', (event) => {
                    Object.keys(hostedFieldsClassStruture).forEach((field, a, v) => {
                        if (event.emittedBy === field) {
                            const selectorToAddClass = document.
                                querySelector(hostedFieldsClassStruture[field].selector);
                            selectorToAddClass.classList.add(hostedFieldsClassStruture[field].focusClass);
                            v.forEach((val) => {
                                if (val !== field) {
                                    const selectorToRemoveClass = document.
                                        querySelector(hostedFieldsClassStruture[val].selector);
                                    selectorToRemoveClass.classList.remove(hostedFieldsClassStruture[val].focusClass);
                                }
                            })
                        }
                    });
                });
                hostedFieldsInstance.setAttribute({
                    field: 'number',
                    attribute: 'aria-required',
                    value: true
                });
                hostedFieldsInstance.setAttribute({
                    field: 'cvv',
                    attribute: 'aria-required',
                    value: true
                });
                hostedFieldsInstance.setAttribute({
                    field: 'expirationMonth',
                    attribute: 'aria-required',
                    value: true
                });
                hostedFieldsInstance.setAttribute({
                    field: 'expirationYear',
                    attribute: 'aria-required',
                    value: true
                });
                hostedFieldsInstance.on('validityChange', (event) => {
                    const selectorValue = hostedFieldsClassStruture[event.emittedBy];
                    const field = event.fields[event.emittedBy];
                    const fieldSelector = document.querySelector(selectorValue.selector);
                    const invalidFieldselector = hostedFieldsRequiredAndInvalid[event.emittedBy].invalid;
                    const invalidField = document.querySelector(`.${invalidFieldselector}`);
                    const expiryDateFields = ['expirationMonth', 'expirationYear'];
                    let isDateValid = false;

                    expiryDateFields.forEach((key) => {
                        const datefield = event.fields[key];
                        isDateValid = isDateValid ? isDateValid : !datefield.isEmpty && !datefield.isValid;
                    })
                    if (!field.isValid && !field.isEmpty) {
                        fieldSelector.classList.add('tc-hosted-field-error');
                        invalidField.classList.add('show-invalid-message');
                    } else if (field.isValid) {
                        fieldSelector.classList.remove('tc-hosted-field-error');
                        invalidField.classList.remove('show-invalid-message');
                    }

                    if (isDateValid) {
                        invalidField.classList.add('show-invalid-message');
                    } else {
                        invalidField.classList.remove('show-invalid-message');
                    }
                });
                hostedFieldsInstance.on('notEmpty', (event) => {
                    const selectorValue = hostedFieldsClassStruture[event.emittedBy];
                    const highlightedEmptyItem = document.querySelector(`.${hostedFieldsRequiredAndInvalid[event.emittedBy].required}`);
                    const numberCvvSeletor = document.querySelector(selectorValue.selector);
                    numberCvvSeletor.classList.remove('tc-hosted-field-error');
                    if (highlightedEmptyItem !== null) {
                        highlightedEmptyItem.classList.remove('valid-field');
                    }
                });
                hostedFieldsInstance.on('empty', (event) => {
                    const selectorValue = hostedFieldsClassStruture[event.emittedBy];
                    const highlightedEmptyItem = document.querySelector(`.${hostedFieldsRequiredAndInvalid[event.emittedBy].required}`);
                    const invalidField = document.querySelector(`.${hostedFieldsRequiredAndInvalid[event.emittedBy].invalid}`);
                    const numberCvvSeletor = document.querySelector(selectorValue.selector);
                    numberCvvSeletor.classList.add('tc-hosted-field-error');
                    if (highlightedEmptyItem !== null) {
                        invalidField.classList.remove('show-invalid-message');
                        highlightedEmptyItem.classList.add('valid-field');
                    }
                });
                this.hostedFields = hostedFieldsInstance;
                onHostedFieldInstanceCallback(hostedFieldsInstance);
            }
        });
    }

    public onError = (err) => {
        return err
    }
    public tokenizeMethod = (onTokenizeCallback) => {
        this.hostedFields?.tokenize((err, payload) => {
            if (err) {
                validateHostedFields(err, this.hostedFields);
            } else {
                const finalPayload = {
                    payload,
                    deviceData: JSON.parse(this.deviceData)
                };
                onTokenizeCallback(finalPayload);
            }
        })
    }
    public tokenizeMethodAble = (onTokenizeCallback) => {
        this.hostedFields?.tokenize((err, payload) => {
            if (err) {
                validateHostedFieldsAble(err, this.hostedFields);
            } else {
                const finalPayload = {
                    payload,
                    deviceData: JSON.parse(this.deviceData)
                };
                onTokenizeCallback(finalPayload);
            }
        })
    }
}
